import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop: FC = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location]);

  return <>{children}</>;
};

export { ScrollTop };
